import { useMemo } from 'react';
import { useCargoIds } from '@/entities/cargo-id/modules/models/useCargoIds';

export type CargoIdGateStatus = 'loading' | 'error' | 'ready' | 'none';

export type CargoIdGate = {
  status: CargoIdGateStatus;
  refetch: () => void;
};

/**
 * Derives the parcel-creation gate from the user's single Cargo ID.
 * Cargo IDs are issued immediately (no admin approval), so the gate is just
 * "has a Cargo ID" (ready) vs "has none" (none), plus loading/error.
 */
export const useCargoIdGateStatus = (): CargoIdGate => {
  const query = useCargoIds();

  return useMemo<CargoIdGate>(() => {
    const refetch = (): void => void query.refetch();
    if (query.isLoading) return { status: 'loading', refetch };
    if (query.isError) return { status: 'error', refetch };
    return { status: query.data ? 'ready' : 'none', refetch };
  }, [query.isLoading, query.isError, query.data, query]);
};
